import styled from 'styled-components';

export const PromptTextarea = styled.textarea`
  width        : 100%;
  border       : 1px solid #e0e0e0;
  border-radius: 12px;
  padding      : 12px;
  font-family  : inherit;
  font-size    : 14px;
  resize       : vertical;

  &:focus {
    outline: #e0e0e0 solid 1px;
  }
`;
